import { render, staticRenderFns } from "./PinglunDetail.vue?vue&type=template&id=1ba7d664&scoped=true"
import script from "./PinglunDetail.vue?vue&type=script&lang=js"
export * from "./PinglunDetail.vue?vue&type=script&lang=js"
import style0 from "./PinglunDetail.vue?vue&type=style&index=0&id=1ba7d664&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba7d664",
  null
  
)

export default component.exports